module.exports = __webpack_public_path__ + "static/media/go-back-icon.6b1555e1.svg";